export default __webpack_public_path__ + "static/media/CC.1bab56d2.svg";